export default __webpack_public_path__ + "static/media/jangwon_nft_11.ab43b664.svg";